<template>
  <div class="contacted-box-container">
    <div v-if="contacted" class="contacted-box">
      <StepTitle :session="session">Give Us a Call or Email Us</StepTitle>
      <div class="centered-block text-center">
        Your query has been submitted. For a faster response please call
        <b-link :href="session && session.phone_contact_url ? session.phone_contact_url : '#'" class="phone btn-link">
          <h2 class="my-2"><font-awesome-icon :icon="['fas', 'phone-alt']"></font-awesome-icon> {{supportPhone}}</h2>
        </b-link>
        <template v-if="session && session.support_email">
          or Email us at
          <b-link :href="session.support_email ? 'mailto:'+session.support_email : '#'" class="phone btn-link">
            <h2 class="my-2"><font-awesome-icon :icon="['fas', 'envelope']"></font-awesome-icon> {{session.support_email}}</h2>
          </b-link>
        </template>
      </div>
    </div>
    <div v-else-if="isLifelinePhone">
      <StepTitle :session="session">
        Give Us a Call
        <template #subtitle>We have a specialist on standby</template>
      </StepTitle>
      <div class="centered-block">
        <b-link :href="session && session.phone_contact_url ? session.phone_contact_url : '#'" class="phone">
          <h2 class="my-2"><font-awesome-icon :icon="['fas', 'phone-alt']"></font-awesome-icon> {{supportPhone}}</h2>
        </b-link>
      </div>
    </div>
    <div v-else-if="isLifelineEmail">
      <StepTitle :session="session" hr>
        <div class="contact-us">Contact Us</div>
        <template #subtitle><div class="mt-3">Fill out the information below and a specialist will contact you shortly</div></template>
      </StepTitle>
      <b-form @submit.prevent="sendMessage()">
        <fieldset v-if="campaign">
          <div class="fields">
            <b-form-group
              v-for="(field, index) in campaign.support_email_fields.filter(item => item !== null)"
              :key="'input-data-field-' + index.toString()"
              :label="field.label"
              :label-for="field.name"
            >
              <b-form-select
                v-if="field.type === 'select'"
                :id="field.name"
                v-model="contactForm[field.name]"
                :options="field.values"
                :required="('required' in field) ? field.required : false"
              >
              </b-form-select>
              <b-form-textarea
                v-else-if="field.type === 'textarea'"
                :id="field.name"
                v-model="contactForm[field.name]"
                :required="('required' in field) ? field.required : false"
                rows="10" no-resize
              >
              </b-form-textarea>
              <b-form-input
                v-else
                :id="field.name"
                v-model="contactForm[field.name]"
                :type="getFieldType(field)"
                :required="('required' in field) ? field.required : false"
              >
              </b-form-input>
              <span v-if="formErrors && formErrors[field.name]" class="text-danger">
                {{formErrors[field.name][0]}}</span>
            </b-form-group>
          </div>
        </fieldset>
        <b-row class="justify-content-md-center mt-3 mb-3">
          <b-col md="5">
            <b-button class="font-weight-bold" block type="submit" variant="primary">Submit</b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LifelineType } from '../constants'
const StepTitle = () => import('./StepTitle')

export default {
  name: 'ContactSupportForm',
  components: {StepTitle},
  props: {
    lifelineType: LifelineType,
    contacted: Boolean,
    formErrors: Object,
    formValues: Object,
    session: Object
  },
  data: function() {
    return {
      contactForm: {}
    }
  },
  computed: {
    ...mapState(['campaign']),
    supportPhone: function() {
      if (!this.session || !this.session.phone_contact_url) {
        return ''
      }
      const pos = (this.session.phone_contact_url[4] === '+') ? 5 : 4

      return this.session.phone_contact_url.slice(pos)
    },
    isChatAvailable: function() {
      return false // not yet supported
    },
    isLifelinePhone: function() {
      return this.lifelineType === LifelineType.Phone
    },
    isLifelineEmail: function() {
      return this.lifelineType === LifelineType.Email
    },
    isLifelineChat: function() {
      return this.lifelineType === LifelineType.Chat
    }
  },
  methods: {
    sendMessage: function() {
      this.$emit('email', this.contactForm)
    },
    getFieldType(field) {
      if (('type' in field) && field.type.length) {
        if (field.type === 'phone') {
          return 'tel'
        } else {
          return field.type
        }
      }

      return 'text' // default field type
    }
  },
  created() {
    if (this.campaign && this.campaign.support_email_fields && this.campaign.support_email_fields.length) {
      // set the contact form fields and default values
      this.contactForm = {}

      this.campaign.support_email_fields.filter(field => field !== null).forEach(field => {
        this.contactForm[field.name] = null

        if (this.session && this.session.customer) {
          if (field.name === 'email') {
            this.contactForm.email = this.session.customer.email
          } else if (field.name === 'phone') {
            this.contactForm.phone = this.session.customer.phone
          } else if (field.name === 'first_name') {
            this.contactForm.first_name = this.session.customer.first_name
          } else if (field.name === 'last_name') {
            this.contactForm.last_name = this.session.customer.last_name
          } else if (field.name === 'name') {
            this.contactForm.name = this.session.customer.first_name + ' ' + this.session.customer.last_name
          }
        }

        if (this.contactForm[field.name] === null && this.formValues && this.formValues[field.name]) {
          this.contactForm[field.name] = this.formValues[field.name]
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  .btn-link {
    color: var(--theme_color) !important;
  }
</style>
